import React from 'react';
import SEOHead from '../components/SEOHead';
import Hero from '../components/Hero';
import SearchSection from '../components/SearchSection';
import Categories from '../components/Categories';
import StateStreamSection from '../components/StateStreamSection';
import HowItWorks from '../components/HowItWorks';
import TopReviews from '../components/TopReviews';
import PersonalizedListSection from '../components/PersonalizedListSection'; 
import WhyGradVikalp from '../components/WhyGradVikalp';
import BlogSection from '../components/BlogSection';
import Newsletter from '../components/Newsletter'; 


const Home = () => {
  return (
    <>
      <SEOHead 
        title="Grad Vikalp - Find Your Dream College | College Guidance Platform"
        description="Find your dream college with Grad Vikalp! Get verified student reviews, personalized college recommendations, and connect with real students. Your trusted partner for JEE, NEET, and college admissions guidance."
        keywords="college admission, JEE colleges, NEET colleges, college reviews, personalized college list, engineering colleges, medical colleges, college guidance, student reviews, college comparison, admission counseling"
        url="/" 
        type="website"
        pageKey="home"
      />
      <Hero />
      <SearchSection />
      <Categories />
      <StateStreamSection />
      <HowItWorks />
      <TopReviews />
      <PersonalizedListSection /> 
      <WhyGradVikalp />
      <BlogSection />
      <Newsletter />
    </>
  );
};

export default Home;
